import axios from 'axios';
import user from '../utils/user';

export default {

  async getActiveWallets() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/wallet`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
}
